"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BaseProvider = /** @class */ (function () {
    function BaseProvider(provider) {
        this.provider = provider;
    }
    BaseProvider.prototype.component = function (children) {
        return React.createElement(React.Fragment, null, children);
    };
    BaseProvider.prototype.onRender = function (htmlPage) {
        return htmlPage;
    };
    return BaseProvider;
}());
exports.BaseProvider = BaseProvider;
//# sourceMappingURL=BaseProvider.js.map